import React from 'react';
import classnames from 'classnames';
import LogoSvg from './LogoSvg';
import LogoSvgFull from './LogoSvgFull';
import { MainFrameContext } from '../../index';
const Logo = (props) => {
    const { render, collapsed } = props;
    const { prefixCls } = React.useContext(MainFrameContext);
    const renderLogo = () => {
        if (render) {
            return render(collapsed);
        }
        return collapsed ? React.createElement(LogoSvg, null) : React.createElement(LogoSvgFull, null);
    };
    const logo = renderLogo();
    return React.createElement(React.Fragment, null, logo && React.createElement("div", { className: classnames(`${prefixCls}-logo`) }, logo));
};
export default Logo;
